export const ERROR_CODES = {
  INSUFFICIENT_TOKENS: 'INSUFFICIENT_TOKENS'
} as const;
